import { types } from './reducer'
import { RSAA } from 'redux-api-middleware'
import entryPoint from '../../constants/endpoints'
import {actions as mainActions } from '../Root/actions'

export const actions = {
  getRevenue: (data) => dispatch => dispatch({

  }),
  getProductTypeList: () => ({
    [RSAA]: {
      types: [
        {
          type: types.PRODUCT_TYPE_LIST_REQUEST,
          payload: (action, state, res) => {
            return
          }
        },
        {
          type: types.PRODUCT_TYPE_LIST_SUCCESS,
          payload: (action, state, res) => res.json()
            .then((data) => {
              return data
            })
        },
        {
          type: types.PRODUCT_TYPE_LIST_FAILURE,
          payload: (action, state, res) => {
            return
          }

        }
      ],
      endpoint: `${entryPoint}/producttypeList`,
      credentials: 'include',
      method: 'GET'
    }
  }),
  createProductType: (data) => dispatch => dispatch({
    [RSAA]: {
      types: [
        {
          type: types.PRODUCT_TYPE_CREATE_REQUEST,
          payload: (action, state, res) => {
            return
          }
        },
        {
          type: types.PRODUCT_TYPE_CREATE_SUCCESS,
          payload: (action, state, res) => res.json()
            .then(({ data }) => { 
              dispatch(mainActions.redirectTo('/producttypelist'))
              return
            })
        },
        {
          type: types.PRODUCT_TYPE_CREATE_FAILURE,
          // Сервер отказал (например, такая культура уже есть) или не ответил: человек видит это
          // сообщением, а не пустой реакцией на кнопку.
          payload: (action, state, res) =>
            (res && res.json ? res.json() : Promise.resolve({}))
              .catch(() => ({}))
              .then((data) => {
                dispatch(mainActions.showAlert({
                  show: true,
                  alertTitle: 'Ошибка при создании культуры',
                  alertText: data && typeof data.message === 'string'
                    ? data.message
                    : 'Не удалось создать культуру, попробуйте ещё раз',
                  severity: 'error',
                  style: {},
                  variant: 'outlined'
                }))
                return
              })
        }
      ],
      endpoint: `${entryPoint}/createproducttype`,
      credentials: 'include',
      method: 'POST',
      body: JSON.stringify(data),
      headers: { 'Content-Type': 'application/json'}
    }
  }),
}
